// Import and register stimulus controllers
import genericControllers from './**/*_controller.js'

genericControllers.forEach((controller) => {
  Stimulus.register(controller.name, controller.module.default)
})
